import * as UI from "@iyk/ui"
import * as React from "react"

import { appConfig } from "../../../app-config.ts"
import { VerifiedProfileIcon } from "./icons.tsx"
import { Link, Routes } from "./link.tsx"

export const UserProfileCard = (props: UserProfileCard.Props) => {
  const hasAtLeastOneProof = props.totalCheckIns > 0 || props.totalMerchOwned > 0
  const totalProofs = props.totalCheckIns + props.totalMerchOwned
  return (
    <Link
      to={Routes.collection(props.userId)}
      className="flex flex-col justify-between p-3 rounded border border-white/[10%] bg-white/[3%] aspect-video"
    >
      <UI.Avatar
        src={appConfig.assets.images.avatar}
        alt={`${appConfig.artist.name} logo`}
        className="size-7"
        variant="square"
      />
      {hasAtLeastOneProof ? (
        <div className="flex items-center gap-3">
          <VerifiedProfileIcon className="size-5" />
          <div className={classForUserLabel}>
            {props.variant === "profile" ? (
              <React.Fragment>
                <span>{props.username}</span>
                <br />
                <span>Since {props.since}</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span className="text-gray-11">Owner:</span>
                <br />
                <span>{props.username}</span>
              </React.Fragment>
            )}
          </div>
        </div>
      ) : (
        <span className={classForUserLabel}>{props.username}</span>
      )}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <UI.Icon.Proof />
          <span className="text-2xs font-departure-mono">{totalProofs}</span>
        </div>
        <span className={UI.classForButton({ size: "sm", kind: "shaded" })}>
          <UI.Icon.Eye />
        </span>
      </div>
    </Link>
  )
}

const classForUserLabel = UI.cx("uppercase text-[11px] leading-[16px] tracking-upper font-departure-mono")

namespace UserProfileCard {
  export type Props = {
    userId: string
    username: string
    since: string
    totalCheckIns: number
    totalMerchOwned: number
    variant: "owner" | "profile"
  }
}
